import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'

export function ReasonDialog({ reason, carrier }: { reason: string; carrier: string }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          Reason
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reason — {carrier}</DialogTitle>
        </DialogHeader>
        {reason ? (
          <p className="text-sm whitespace-pre-wrap">{reason}</p>
        ) : (
          <p className="text-muted-foreground text-sm">No reason provided.</p>
        )}
      </DialogContent>
    </Dialog>
  )
}
